import { useEffect, useState } from "react";
import { MODULE_API } from "../../../../apis";
const ParentModules = [
  "Personal and Family Information",
  "Emergency Contacts",
  "Property Documentation",
  "Financial Documentation",
  "Important Documents Storage",
  "Emergency Supplies Inventory",
  "Evacuation Planning",
  "Home Safety And Security",
  "Communication Plan",
  "Insurance Coverage",
  "Recovery Plan",
];

export default function useGetAttributes(moduleNames, setLoading) {
  const [attributes, setAttributes] = useState([]);
  const [disasterAttribute, SetDisasterAttribute] = useState(null);
  const [error, setError] = useState(null);

  const getAttributes = async () => {
    setLoading(true);
    setError(null);

    try {
      const results = await Promise.all(
        moduleNames &&
          moduleNames.map(async (name) => {
            try {
              const res = await MODULE_API.fetchAttributes(name);
              console.log("resss", res);
              if (res && ParentModules.includes(res.name)) {
                console.log("res.attributes", res.attributes);
                SetDisasterAttribute(res.attributes);
              }
              return res && res.attributes ? { name: name, attributes: res.attributes } : null;
            } catch (err) {
              console.error(`Error fetching attributes for ${name}:`, err);
              return null;
            }
          })
      );
      console.log("check", results);
      setAttributes(results && results);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (moduleNames && moduleNames.length > 0) {
      getAttributes();
    }
  }, []);

  return { attributes, disasterAttribute, error };
}
